import { useEffect, useState, RefObject } from 'react';
import { findFirstFocusable } from '../utils';

const useFocusOnActive = <T extends HTMLElement>(ref: RefObject<T>, currentAnchor: RefObject<T> | null): boolean => {
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    const activate = currentAnchor === ref;
    setIsActive(activate);
    if (activate) {
      const firstFocusable = findFirstFocusable(ref?.current as T);
      firstFocusable?.focus();
    }
  }, [ref, currentAnchor]);
  return isActive;
};

export default useFocusOnActive;
